module.exports = "/images/69db58faa7f8614dafec8d6e63fb55c0.jpg";